var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2775CA;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,493.5c134.9,0,243.5-108.6,243.5-243.5S384.9,6.5,250,6.5S6.5,115.1,6.5,250S115.1,493.5,250,493.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317,288.6c0-35.5-21.3-47.7-63.9-52.8c-30.4-4.1-36.5-12.2-36.5-26.4s10.1-23.3,30.4-23.3 c18.3,0,28.4,6.1,33.5,21.3c1,3,4.1,5.1,7.1,5.1h16.2c4.1,0,7.1-3,7.1-7.1v-1c-4.1-22.3-22.3-39.6-45.7-41.6v-24.4 c0-4.1-3-7.1-8.1-8.1h-15.2c-4.1,0-7.1,3-8.1,8.1v23.3c-30.4,4.1-49.7,24.4-49.7,49.7c0,33.5,20.3,46.7,62.9,51.7 c28.4,5.1,37.5,11.2,37.5,27.4c0,16.2-14.2,27.4-33.5,27.4c-26.4,0-35.5-11.2-38.6-26.4c-1-4.1-4.1-6.1-7.1-6.1h-17.2 c-4.1,0-7.1,3-7.1,7.1v1c4.1,25.4,20.3,43.6,53.8,48.7v24.4c0,4.1,3,7.1,8.1,8.1h15.2c4.1,0,7.1-3,8.1-8.1v-24.4 C296.7,337.3,317,315.9,317,288.6L317,288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.3,395.1C119.1,366.7,78.5,278.4,108,200.3c15.2-42.6,48.7-75.1,90.3-90.3c4.1-2,6.1-5.1,6.1-10.1V85.6 c0-4.1-2-7.1-6.1-8.1c-1,0-3,0-4.1,1C97.8,109,45.1,211.4,75.5,307.8c18.3,56.8,61.9,100.4,118.7,118.7c4.1,2,8.1,0,9.1-4.1 c1-1,1-2,1-4.1v-14.2C204.3,401.2,201.3,397.1,198.3,395.1z M305.8,78.5c-4.1-2-8.1,0-9.1,4.1c-1,1-1,2-1,4.1v14.2 c0,4.1,3,8.1,6.1,10.1c79.1,28.4,119.7,116.7,90.3,194.8c-15.2,42.6-48.7,75.1-90.3,90.3c-4.1,2-6.1,5.1-6.1,10.1v14.2 c0,4.1,2,7.1,6.1,8.1c1,0,3,0,4.1-1c96.4-30.4,149.1-132.9,118.7-229.3C406.2,140.4,361.6,96.8,305.8,78.5L305.8,78.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/USDC.721d4aa370ee6c624780b44cc72123cf.svg";